import {
    Box,
    Button,
    CircularProgress,
    Grid,
    Link,
    MenuItem,
    Select,
    TextField,
    Typography,
    makeStyles,
} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {useState} from 'react';

const SHORT_URL_STORAGE_KEY = 'SHORT_URL_STORAGE';

const useStyles = makeStyles(() => ({
    pageLabel: {
        paddingLeft: '4pt',
        color: '#626EA7',
        fontFamily: 'LoraSemiBold',
        fontSize: '32px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '120%' /* 38.4px */,
    },
}));

const UrlShortener = observer(() => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [isCopying, setIsCopying] = useState(false);
    const [url, setUrl] = useState('');
    const [urlError, setUrlError] = useState('');
    const [shortUrl, setShortUrl] = useState('');
    const [urlType, setUrlType] = useState<'BLOG' | 'LANDING_PAGE' | 'PARTNER' | 'OTHER'>('OTHER');

    function isValidHttpUrl(s: string) {
        let url;

        try {
            url = new URL(s);
        } catch (_) {
            return false;
        }

        return url.protocol === 'http:' || url.protocol === 'https:';
    }

    function handleTinyUrl(shortUrl: string) {
        setShortUrl(shortUrl);
    }

    function makeTinyUrl() {
        const currentUrl = url;

        if (!isValidHttpUrl(url)) {
            setUrlError('Not a valid url');
            return;
        }

        if (currentUrl) {
            setIsLoading(true);
            try {
                setShortUrl('');
                fetch(`/url-shortener-api/url`, {
                    method: 'POST',
                    body: JSON.stringify({fullUrl: currentUrl, type: urlType}),
                }).then((response: any) => {
                    setIsLoading(false);
                    response.json().then((body: any) => {
                        const shortUrl = body?.result?.shortUrl;
                        handleTinyUrl(shortUrl);
                    });
                });
            } catch (e) {
                console.error(e);
                setIsLoading(false);
            }
        }
    }

    function handleShortUrlClick(e: MouseEvent, shortUrl: string) {
        setIsCopying(true);
        navigator.clipboard.writeText(shortUrl);
        setTimeout(() => {
            setIsCopying(false);
        }, 500);
        e.preventDefault();
    }

    return (
        <div style={{width: '100%'}}>
            <Grid container justify={'center'} alignItems={'center'}>
                <Typography variant="h6" classes={{root: classes.pageLabel}}>
                    Url Shortener
                </Typography>
            </Grid>
            <form
                onSubmit={(e) => {
                    makeTinyUrl();
                    e.preventDefault();
                }}
            >
                <Box style={{padding: '20px 200px'}}>
                    <Grid container spacing={3} direction="column">
                        <TextField
                            id={`url`}
                            label="Full Url"
                            variant="standard"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={url}
                            onChange={(e) => {
                                setUrlError('');
                                setUrl(e.target.value);
                            }}
                            helperText={urlError}
                        />
                        <Select name="privateInfo" value={urlType} onChange={(e) => setUrlType(e.target.value as any)}>
                            <MenuItem value="BLOG">Blog Post</MenuItem>
                            <MenuItem value="LANDING_PAGE">Landing Page</MenuItem>
                            <MenuItem value="PARTNER">Partner Link</MenuItem>
                            <MenuItem value="OTHER">Other</MenuItem>
                        </Select>
                        <Button style={{margin: '20px'}} variant="outlined" disabled={!url} type="submit">
                            Generate Tiny Url
                        </Button>
                        {isLoading && (
                            <Box
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '200px',
                                }}
                            >
                                <CircularProgress size={30} />
                            </Box>
                        )}
                        {shortUrl && (
                            <Box>
                                <Typography>
                                    Short Url (Click to copy):{' '}
                                    <Link
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: isCopying ? '#456d69' : 'unset',
                                            color: isCopying ? '#FFF' : 'blue',
                                        }}
                                        onClick={(e) => handleShortUrlClick(e as any, shortUrl)}
                                    >
                                        {shortUrl}
                                    </Link>
                                </Typography>
                            </Box>
                        )}
                    </Grid>
                </Box>
            </form>
        </div>
    );
});

export default UrlShortener;
